import { useMutation, UseMutationConfig } from '@libs/use';
import { CreateBankAccountRequest } from '@libs/api-reference';

import * as API from '../requests';

type UseCreateSamanPaymentTokenQueryParamsType = {
  onReject?: UseMutationConfig<object>['onReject'];
  onSuccess?: UseMutationConfig<object>['onSuccess'];
};

type CreateBankAccountFormModel = { bankAccountNumber: null | string };

function createBankAccountFactory(form: CreateBankAccountFormModel) {
  return {
    iBan: form.bankAccountNumber,
  };
}

export default function useCreateBankAccountQuery({
  onReject,
  onSuccess,
}: UseCreateSamanPaymentTokenQueryParamsType = {}) {
  const {
    execute: createBankAccount,
    isPending: isCreatingBankAccount,
    ...query
  } = useMutation<CreateBankAccountRequest>(
    (data: CreateBankAccountFormModel) =>
      API.createBankAccount(createBankAccountFactory(data)),
    {
      onReject,
      onSuccess,
    }
  );

  return { createBankAccount, isCreatingBankAccount, ...query };
}
